export default function leaveRequestStatusHandler(status) {
  switch (status) {
    case 10:
      return 'PENDING'
    case 11:
      return 'REJECTED'
    case 12:
      return {
        text: 'Awaiting Confirmation',
        color: 'yellow-01.main',
        bgColor: 'light-yellow-01.main',
      }
    case 13:
      return {
        text: 'Confirmed',
        color: 'alternate.main',
        bgColor: 'alternate.light',
      }
    case 14:
      return 'PENDING_DOCUMENT'
    case 15:
      return {
        text: 'Attached',
        color: 'yellow-01.main',
        bgColor: 'light-yellow-01.main',
      }
    case 16:
      return 'WITHDRAWN'
    case 17:
      return 'APPROVED'
    case 18:
      return {
        text: 'Completed',
        color: 'alternate.main',
        bgColor: 'alternate.light',
      }

    default:
      return {
        text: 'Default',
        color: 'yellow-01.main',
        bgColor: 'light-yellow-01.main',
      }
  }
}
